import React, { useState } from 'react';
import Logo from "../../assets/images/logo-white.svg";
import {getLastSession} from '../../Data/SessionData.js';
import { fogotPassword, resetPassword } from '../../RestUtil.js';

function ForgotPassword() {

  const [email, setEmail] = useState(null);
  const [otp, setOtp] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [showOtp, setShowOtp] = useState(false);

  function handleForgot() {
    var sessionData = getLastSession();
    if (showOtp) {
      console.log("now invoking resetPassword with session "+sessionData.id+" and email "+email+" otp "+otp+" newpass "+newPassword);
      resetPassword(sessionData.id,email,otp,newPassword).then(resp => {
        console.log("resetPassword resp",resp);
        if (resp == "success") {
          setShowOtp(false);
          alert("Your password has been reset, please login with the new password");
          window.location = "login";
        }
        else {
          setShowOtp(false);
        }
    })
    .catch(err2 => {
      console.log("fogotPassword failed",err2);          
    });
    }
    else {
      console.log("now invoking forgotPassword with session "+sessionData.id+" and email",email);
      fogotPassword(sessionData.id,email).then(resp => {
          console.log("fogotPassword resp",resp);
          if (resp == "success") {
            setShowOtp(true);
            alert("Please check your email and enter OTP");
          }
          else {
            setShowOtp(false);
          }
      })
      .catch(err2 => {
        console.log("fogotPassword failed",err2);          
      });
    }
  }

  return (
      <div className="theme-cyan">
        <div >
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main">
              <div className="auth-box">
                <div className="top">
                   <img src="images/logo2.png" alt="Lucid" style={{ height: "40px", margin: "10px" }} />
                </div>
                <div className="card">
                  <div className="header">
                    <p className="lead">Recover my password</p>
                  </div>
                  <div className="body">
                    <p>Please enter your email address below to receive instructions for resetting password.</p>
                    <form className="form-auth-small ng-untouched ng-pristine ng-valid">
                      <div className="form-group">
                      <input
                          className="form-control"
                          id="forgot-email"
                          placeholder="Email"
                          type="email"
                          value={email}
                          onChange={val => {
                            setEmail(val.target.value);
                          }}
                        />
                        {showOtp && 
                          <div>
                            <br/>
                            <input
                            className="form-control"
                            id="forgot-otp"
                            placeholder="otp"
                            type="text"
                            value={otp}
                            onChange={val => {
                              setOtp(val.target.value);
                            }}
                            />
                            <br/>
                            <input
                            className="form-control"
                            id="forgot-password"
                            placeholder="New Password"
                            type="password"
                            value={newPassword}
                            onChange={val => {
                              setNewPassword(val.target.value);
                            }}
                            />
                          </div>
                        }
                      </div>                      
                      <button className="btn btn-primary btn-lg btn-block" type="button" onClick={handleForgot}>
                        RESET PASSWORD
                      </button>
                      <div className="bottom">
                        <span className="helper-text">Know your password? <a href="login">Login</a></span>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  export default ForgotPassword;
  